/* @flow */

import * as React from 'react';
import Select, {mergeStyles, type ActionMeta, type SelectBaseProps} from 'react-select';

import {colors} from 'shells/colors';

import {selectPickerGenericStyles} from './select-picker-generic-styles';

type Props = {|
    ...$Exact<SelectBaseProps>,
    value?: ?(Object[]),
    options: Object[],
    isMulti: boolean,
    valueKey?: string,
    labelKey?: string,
    hasError?: ?boolean,
    onClear?: () => void,
    onChange?: (newValue: Object, actionMeta: ActionMeta) => void,
|};

export function SelectPickerGenericMulti(props: Props) {
    const {styles, hasError, onClear, onChange, ...restProps} = props;

    const componentStyles = {
        control: (base) => ({
            ...base,
            border: hasError ? `1px solid ${colors.rose}` : `1px solid ${colors.offWhiteMd}`,
        }),
        placeholder: (base) => ({
            ...base,
            color: base.color,
            transition: 'color 200ms linear',
        }),
        singleValue: (base) => ({
            ...base,
            color: colors.grey,
            transition: 'color 200ms linear',
        }),
        indicatorSeparator: (base) => ({
            ...base,
            display: onClear ? undefined : 'none',
        }),
        multiValueRemove: (base) => ({
            ...base,
            '&:hover': {
                backgroundColor: '#e6e6e6;',
                color: 'black',
            },
        }),
    };

    let mergedStyles = mergeStyles(selectPickerGenericStyles, componentStyles);

    // Add in styles from props
    if (styles) {
        mergedStyles = mergeStyles(mergedStyles, styles);
    }

    const handleChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'clear' || newValue === null || typeof newValue === 'undefined') {
            if (onClear) {
                onClear();
            }
        } else if (onChange) {
            onChange(newValue, actionMeta);
        }
    };

    return <Select {...restProps} isMulti={true} onChange={handleChange} styles={mergedStyles} />;
}
